import { useLayoutEffect } from 'react';
export const useDetectOffScreen = _ref => {
  let {
    elementRef,
    onInterfaceDidMoveOutsideOfScreenBounds
  } = _ref;
  useLayoutEffect(() => {
    const {
      current
    } = elementRef;
    if (current !== null) {
      const rect = current.getBoundingClientRect();
      const isVerticallyOffScreen = current.offsetHeight > rect.bottom;
      const isHorizontallyOffScreen = current.offsetWidth > rect.right;
      if (isVerticallyOffScreen || isHorizontallyOffScreen) {
        onInterfaceDidMoveOutsideOfScreenBounds({
          htmlElement: current,
          isHorizontallyOffScreen,
          isVerticallyOffScreen
        });
      }
    }
  });
};